const initialState = {
  uploadDocumentPath: null,
  uploadDocumentNewPath: null,
  folderData: null,
  newSubFolder: false,
  subFolderName: null,
};

export default initialState;
